import { useEffect, useState, useCallback, memo, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useFeira } from "../../Contexts/FeiraContext";
import { Button } from 'reactstrap';
import { api } from "../../config";
import { ToastContainer, toast } from 'react-toastify';
import { fetchComAuth, fetchComAuthJson } from '../../common/api';
import Loader from "./Loader";

// Componente de Estande interno para performance e cálculos de Label
const EstandeManutencao = memo(({ pathData, estandeInfo, isSelected, onClick, cores }) => {
  const pathRef = useRef(null);
  const [bboxReady, setBboxReady] = useState(false);
  const {
    corLivre = "rgba(0, 255, 0, 0.3)",
    corReservado = "rgba(255, 165, 0, 0.3)",
    corVendido = "rgba(255, 0, 0, 0.3)",
    corRenovacao = "rgba(255, 0, 0, 0.3)",
    corPendenteRenovacao = "rgba(206, 23, 184, 0.3)",
    legenda,
  } = useFeira()

  useEffect(() => {
    if (pathRef.current) setBboxReady(true);
  }, []);

 let corDeFundo = corLivre;
let fillColor = cores.corLivre;
  if (estandeInfo) {
    switch (estandeInfo.status_reserva_id) {
      case 2: fillColor = cores.corReservado; break;
      case 3: fillColor = cores.corVendido; break;
      case 5: fillColor = cores.corRenovacao; break;
      case 6: fillColor = cores.corPendenteRenovacao; break;
      default: fillColor = cores.corLivre;
    }
  }

  return (
    <g onClick={(e) => onClick(e, estandeInfo?.id)} style={{ cursor: 'pointer' }}>
      <path
        ref={pathRef}
        d={pathData.path}
        fill={fillColor}
        fillOpacity={isSelected ? 0.8 : 0.4}
        stroke={isSelected ? "#007bff" : "#333"}
        strokeWidth={isSelected ? "3" : "1"}
        style={{ pointerEvents: 'auto' }}
      />
      {bboxReady && estandeInfo && (
        <text
          x={pathRef.current.getBBox().x + pathRef.current.getBBox().width / 2}
          y={pathRef.current.getBBox().y + pathRef.current.getBBox().height / 2}
          textAnchor="middle"
          fontSize="12"
          fontWeight="bold"
          style={{ pointerEvents: 'none', fill: '#000' }}
        >
          {estandeInfo.nome}
        </text>
      )}
    </g>
  );
});

const MapaGerenciamento = ({ feiraId }) => {
  const {
    mapData, // Certifique-se que o context provê mapData (com width, height e paths)
    estandesMap, // Map de hash -> dados do estande
    fundoImagem,
    corLivre,
    corReservado,
    corVendido,
    corRenovacao,
    corPendenteRenovacao,
    setEstandesCadastrados
  } = useFeira();

  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  // Estados dos Modais
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [showConfirmLivreModal, setShowConfirmLivreModal] = useState(false);
 const [showConfirmVoltarMapaModal, setShowConfirmVoltarMapaModal] = useState(false);

  const toggleSelection = useCallback((e, id) => {
    e.stopPropagation();
    if (!id) return;
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  }, []);

  const loadEstandes = async () => {
    try {
      const response = await fetchComAuth(`${api.API_URL}/feira/estandes/${feiraId}`, { method: 'GET' });
      const data = await response.json();
      setEstandesCadastrados(data.data);
    } catch (err) {
      console.error("Erro ao recarregar:", err);
    }
  };

const atualizarStatusEstandes = async (livre) => {
    if (selectedIds.length === 0) return;

    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feira/manutencao`, {
        method: 'POST',
        body: JSON.stringify({
          feira_id: feiraId,
          estandes: selectedIds,
          livre: livre
        })
      });

      const data = await response.json();
      if (data.status) {
        toast.success("Atualizado com sucesso!");
        setSelectedIds([]);
        setShowConfirmLivreModal(false);
        setShowConfirmDeleteModal(false);
       
        const novosEstandes = await loadEstandes(); 
        
      } else {
        toast.error("Erro ao atualizar");
        console.error(error);
        setShowConfirmLivreModal(false);
        setShowConfirmDeleteModal(false);
      }
    
        

    } catch (error) {
      toast.error("Erro ao atualizar status");
      console.error(error);
    }
  };


const voltarMapaAnterior = async () => {
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feira/manutencao/${feiraId}`, {
        method: 'POST'
      });

      const data = await response.json();
      
      if (data.success) {
        toast.success("Mapa atualizado com sucesso!");
        setSelectedIds([]);
        setShowConfirmLivreModal(false);
        setShowConfirmDeleteModal(false);
        setShowConfirmVoltarMapaModal(false);
        const novosEstandes = await loadEstandes(); 

      } else {
        toast.error("Erro ao atualizar");
        console.error(error);
        setShowConfirmLivreModal(false);
        setShowConfirmDeleteModal(false);
        setShowConfirmVoltarMapaModal(false);
      }

    } catch (error) {
      toast.error("Erro ao atualizar mapa");
      console.error(error);
    }
  };


const tornarEspacoLivre = async () => {
    await atualizarStatusEstandes(1);
  };

  const excluirEspaco = async  () => {
    await atualizarStatusEstandes(0);
  };

  const voltarMapa = async  () => {
    await voltarMapaAnterior();
  };



  const executarAcao = async (livre) => {

    setLoading(true);
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feira/manutencao`, {
        method: 'POST',
        body: JSON.stringify({
          feira_id: feiraId,
          estandes: selectedIds,
          livre: livre
        })
      });
      const data = await response.json();
      if (data.status) {
        toast.success("Operação realizada com sucesso!");
        setSelectedIds([]);
        await loadEstandes();
      }
    } catch (error) {
      toast.error("Erro na comunicação com a API");
    } finally {
      setLoading(false);
      setShowConfirmLivreModal(false);
      setShowConfirmDeleteModal(false);
    }
  };

  if (!mapData) return <Loader />;

  return (
    <>
      <ToastContainer />
      
      {/* Barra de Ferramentas */}
      <div className="d-flex gap-2 mb-3">
        <Button 
          color="success" 
          disabled={selectedIds.length === 0 || loading}
          onClick={() => setShowConfirmLivreModal(true)}
        >
          TORNAR LIVRE ({selectedIds.length})
        </Button>
        <Button 
          color="danger" 
          disabled={selectedIds.length === 0 || loading}
          onClick={() => setShowConfirmDeleteModal(true)}
        >
          EXCLUIR ESPAÇO
        </Button>
    
          <Button 
            color="primary" 
            onClick={() => setShowConfirmVoltarMapaModal(true)}
          >
            VOLTAR ÚLTIMO MAPA
          </Button>
        </div>


      {/* Container do Mapa (Lógica do MapaVisualizador) */}
      <div style={{ width: '100%', height: 'calc(100vh - 250px)', position: 'relative', background: '#eee' }}>
        <TransformWrapper initialScale={1} minScale={0.2} maxScale={8}>
          <TransformComponent wrapperStyle={{ width: '100%', height: '100%' }}>
            <svg
              viewBox={`0 0 ${mapData.width} ${mapData.height}`}
              style={{ width: '100%', height: '100%' }}
            >
              {fundoImagem && (
                <image href={fundoImagem} width={mapData.width} height={mapData.height} />
              )}
              <g>
                {Object.values(mapData.paths).map((pathData) => (
                  <EstandeManutencao
                    key={pathData.hash}
                    pathData={pathData}
                    estandeInfo={estandesMap.get(pathData.hash)}
                    isSelected={selectedIds.includes(estandesMap.get(pathData.hash)?.id)}
                    onClick={toggleSelection}
                    cores={{ corLivre, corReservado, corVendido, corRenovacao, corPendenteRenovacao }}
                  />
                ))}
              </g>
            </svg>
          </TransformComponent>
        </TransformWrapper>
      </div>

     {showConfirmVoltarMapaModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
          display: "flex", justifyContent: "center", alignItems: "center"
        }}>
          <div style={{
            backgroundColor: "#fff", padding: "2rem", borderRadius: "8px",
            maxWidth: "500px", width: "95%", textAlign: "center"
          }}>
            <h4 style={{ color: "#d32f2f" }}>Tem certeza que deseja voltar o último mapa?</h4>
            <p>Essa ação não poderá ser desfeita.</p>

            <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
              <button
                onClick={() => setShowConfirmVoltarMapaModal(false)}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px"
                }}
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  await voltarMapa();
                }}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px"
                }}
              >
                Sim, voltar
              </button>
            </div>
          </div>
        </div>
      )}

       {showConfirmDeleteModal && (
              <div style={{
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
                display: "flex", justifyContent: "center", alignItems: "center"
              }}>
                <div style={{
                  backgroundColor: "#fff", padding: "2rem", borderRadius: "8px",
                  maxWidth: "500px", width: "95%", textAlign: "center"
                }}>
                  <h4 style={{ color: "#d32f2f" }}>Tem certeza que deseja excluir?</h4>
                  <p>Essa ação não poderá ser desfeita.</p>
    
                  <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
                    <button
                      onClick={() => setShowConfirmDeleteModal(false)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#6c757d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={async () => {
                        await excluirEspaco();
                      }}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                      }}
                    >
                      Sim, excluir
                    </button>
                  </div>
                </div>
              </div>
        )}

        {showConfirmLivreModal && (
              <div style={{
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
                display: "flex", justifyContent: "center", alignItems: "center"
              }}>
                <div style={{
                  backgroundColor: "#fff", padding: "2rem", borderRadius: "8px",
                  maxWidth: "500px", width: "95%", textAlign: "center"
                }}>
                  <h4> Deseja realmente mudar o status para livre?</h4>
                  <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
                    <button
                      onClick={() => setShowConfirmLivreModal(false)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#6c757d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      onClick={async () => {
                        await tornarEspacoLivre();
                      }}
                      className="bt-success"
                      style={{
                        padding: "0.5rem 1rem",
                       
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                      }}
                    >
                      Sim
                    </button>
                  </div>
                </div>
              </div>
        )}

    </>
  );
};

export default MapaGerenciamento;

       
